import {List} from 'models/list';
import {Attendance} from 'models/attendance';

const state = {
  attendance: new List(),
  chartData: null
};

const getters = {
  attendance: (state) => state.attendance,
  chartData: (state) => state.chartData
};

const actions = {
  async fetchAttendanceSummary({commit}, data) {
    commit('setLoading', true);
    try {
      const formData = new FormData();
      for (const key in data) {
        if (key === 'file' && data.file) {
          formData.append('file', data.file);
        } else if (Array.isArray(data[key])) {
          if (data[key].length === 0) {
            formData.append(`${key}[]`, '');
          } else {
            data[key].forEach((val) => formData.append(`${key}[]`, val));
          }
        } else if (data[key] !== undefined && data[key] !== null) {
          formData.append(key, data[key]);
        }
      }

      const response = await this.$app.$http.post('/attendance', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        commit('setAttendance', response.data);
        this.$app.$snotify.success(
          this.$app.$t('messages.success.fetched', {
            entity: this.$app.$tc('models.attendance.entity', 1)
          })
        );
        this.$app.$router.push({
          name: 'AttendanceDashboard'
        });
      } else {
        this.$app.$snotify.error(this.$app.$t('messages.error.internalServerError'));
      }
      return response;
    } finally {
      commit('setLoading', false);
    }
  }
};

const mutations = {
  setAttendance(state, responseData) {
    const dataArray = responseData.data || responseData;
    state.attendance = new List({
      items: dataArray.map((attendance) => new Attendance(attendance)),
      count: dataArray.length
    });
    state.chartData = responseData.chart_data || null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
